import type {
  Certification,
  ContactInfo,
  Education,
  ProfessionalSummaryEntry,
  Project,
  ResumeSectionType,
  SkillCategory,
  WorkExperienceCompany,
} from '@applicator/shared'

import type { Interest } from './InterestsEditor'

export type ResumeSectionDataRecord = Record<ResumeSectionType, unknown>

export function createEmptyResumeSectionData(): ResumeSectionDataRecord {
  return {
    contact_info: {} as ContactInfo,
    target_title: [],
    professional_summary: [] as ProfessionalSummaryEntry[],
    work_experience: [] as WorkExperienceCompany[],
    education: [] as Education[],
    skills: [] as SkillCategory[],
    interests: [] as Interest[],
    certifications: [] as Certification[],
    awards_scholarships: [],
    projects: [] as Project[],
  }
}
